import queryString from 'query-string';

type Message<T extends string, V extends object | void = void> = {
  action: T;
} & (V extends object ? { payload: V } : { payload?: never });

export type IncomingMessage<
  T extends string,
  V extends object | void = void,
> = Message<T, V>;
export type OutgoingMessage<
  T extends string,
  V extends object | void = void,
> = Message<T, V>;

/**
 * For local testing use http://embedded.localhost:3000/
 */
export function isEmbedded(): boolean {
  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];

  return (
    // Old: embedded.petroninja.com
    subdomain === 'embedded' ||
    // New: embedded-maps.stackdx.com & staging-embedded-maps.stackdx.com
    hostname.includes('embedded-maps.stackdx.com')
  );
}

export function isInIFrame(): boolean {
  return typeof window !== 'undefined' && window !== window.parent;
}

function isInDebugMode(): boolean {
  return queryString.parse(window.location.search).debug === '1';
}

export const log = {
  debug: (message: string, ...args: any[]) => {
    if (isInDebugMode()) {
      console.log('%c[embedded]', 'color: #009688', message, ...args);
    }
  },
  error: (message: string, ...args: any[]) =>
    console.log('%c[embedded error]', 'color: #F44336', message, ...args),
};
